export default __webpack_public_path__ + "static/media/mail-empty.a90bc8ae.gif";